module.exports = __webpack_public_path__ + "img/inbox.8115c381.svg";